<template>
    <div class="create-stek">
        <Dialog
            header="Create Stek"
            @keyup.esc="cancelCreatingStek"
            v-model:visible="displayCreateStekModal"
            :style="{ width: '50vw' }"
            :closable="false"
            :modal="true"
            :draggable="false"
        >
            <div v-if="errors.length">
                <div v-for="error in errors" :key="error">
                    <Message severity="error" :closable="false">{{
                        error
                    }}</Message>
                </div>
            </div>
            <form v-on:submit.prevent="createStek">
                <Fluid class="field">
                    <label for="stekName">Name</label>
                    <InputText id="stekName" v-model="stekName" autofocus />
                </Fluid>
            </form>
            <template #footer>
                <Button
                    label="Cancel"
                    @click="cancelCreatingStek"
                    class="p-button-secondary"
                />
                <Button label="Create" @click="createStek" />
            </template>
        </Dialog>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import router from "@/router";
import { validateName } from "@/utils";
import { useOrganizationManager } from "@/composables/organization-manager";
import { useSteksStore } from "@/stores/steks-store";

const displayCreateStekModal = ref(true);
const stekName = ref("");
const errors = ref<string[]>([]);
const { organization } = useOrganizationManager();
const { create } = useSteksStore();

const cancelCreatingStek = () => {
    displayCreateStekModal.value = false;
    router.push(`/${organization.value?.name}/steks`);
};

const createStek = async () => {
    if (!stekName.value) return;
    if (!organization.value?.name) return;
    errors.value = validateName(stekName.value);
    if (errors.value.length) return;

    await create(stekName.value);
    router.push(`/${organization.value.name}/steks/${stekName.value}`);
};
</script>
